// Branchen-Vokabular der SiGeKo-Zielgruppen (ERP/CRM-Plan, Abschnitt 4).
//
// EINE Quelle fuer Kunden, spaeter Leads und Karten-Statistik: dieselben
// Schluessel stehen als CHECK-Constraint in supabase/geo_foundation.sql
// (customers_branche_check). Wer hier erweitert, muss dort nachziehen —
// sonst nimmt die Datenbank den neuen Wert nicht an.
//
// Die Schluessel sind bewusst ASCII und kleingeschrieben (keine Umlaute):
// sie stehen in der Datenbank, in URLs und in Exporten. Die Umlaute leben
// ausschliesslich in den Labels.

export const BRANCHEN = [
    'bautraeger',
    'generalunternehmer',
    'architekturbuero',
    'ingenieurbuero',
    'wohnungswirtschaft',
    'kommune_behoerde',
    'industrie_betreiber',
    'projektentwickler',
    'energie_infrastruktur',
    'sonstige',
] as const;

export type Branche = (typeof BRANCHEN)[number];

/** Anzeigetexte. Vollstaendig — Record erzwingt einen Eintrag je Schluessel. */
export const BRANCHE_LABELS: Record<Branche, string> = {
    bautraeger: 'Bauträger',
    generalunternehmer: 'Generalunternehmer',
    architekturbuero: 'Architekturbüro',
    ingenieurbuero: 'Ingenieurbüro',
    wohnungswirtschaft: 'Wohnungswirtschaft',
    kommune_behoerde: 'Kommune / Behörde',
    industrie_betreiber: 'Industrie / Betreiber',
    projektentwickler: 'Projektentwickler',
    energie_infrastruktur: 'Energie / Infrastruktur',
    sonstige: 'Sonstige',
};

/** Label fuer eine ungepflegte Branche (NULL in der Datenbank). */
export const BRANCHE_UNGEPFLEGT = 'Ohne Branche';

/**
 * Gehoert der Wert zum Vokabular? Type Guard, damit ein aus der Datenbank
 * oder einem Import gelesener String ohne Cast als Branche weiterlaeuft.
 */
export const isBranche = (value: unknown): value is Branche =>
    typeof value === 'string' && (BRANCHEN as readonly string[]).includes(value);

/**
 * Anzeigetext zu einem gespeicherten Wert. Unbekannte Werte kaeme es nur ueber
 * einen manuellen Datenbankeingriff (der CHECK laesst sie sonst nicht zu) —
 * sie werden roh durchgereicht statt verschluckt, damit der Fehler sichtbar
 * bleibt. Leer/NULL ergibt "Ohne Branche".
 */
export const brancheLabel = (value?: string | null): string => {
    if (!value) return BRANCHE_UNGEPFLEGT;
    return isBranche(value) ? BRANCHE_LABELS[value] : value;
};

/** Auswahlliste fuer Selects, alphabetisch — 'sonstige' bleibt am Ende. */
export const BRANCHE_OPTIONS: { value: Branche; label: string }[] = BRANCHEN
    .map((value) => ({ value, label: BRANCHE_LABELS[value] }))
    .sort((a, b) => {
        if (a.value === 'sonstige') return 1;
        if (b.value === 'sonstige') return -1;
        return a.label.localeCompare(b.label, 'de');
    });
